module.exports = __webpack_public_path__ + "static/img/ikonaGimpDisabled-OFF.b24bad3d.png";